// extracted by mini-css-extract-plugin
module.exports = {"switch":"ToggleSwitch_switch__3GUlz"};